// Autocomplete: force layout styles (works for open Shadow DOM too)
(function mhAutocompleteInlineStyles() {
  var injectDelayMs = 1000;
  var hostSelector = '.fast-ac-container';
  var observedRoots = new WeakSet();

  function applyInlineStyles(root) {
    try {
      var scope = root && root.querySelectorAll ? root : document;

      var container = scope.querySelectorAll('.autocomplete-inner .fast-wide-products');
      container.forEach(function (cont) {
        if (!cont || !cont.style) return;
        cont.style.setProperty('display', 'flex', 'important');
        cont.style.setProperty('flex-wrap', 'wrap', 'important');
        cont.style.setProperty('gap', '15px', 'important');
        cont.style.setProperty('justify-content', 'flex-start', 'important');
      });

      // Row
      var rows = scope.querySelectorAll('.autocomplete-inner .fast-wide-products .fs-product');
      rows.forEach(function (row) {
        if (!row || !row.style) return;
        row.style.setProperty('display', 'flex', 'important');
        row.style.setProperty('max-height', 'fit-content', 'important');
        row.style.setProperty('flex-direction', 'row', 'important');
        row.style.setProperty('align-items', 'center', 'important');
        row.style.setProperty('gap', '10px', 'important');

        row.style.setProperty('flex', '1 1 300px', 'important');
        row.style.setProperty('min-width', '0', 'important');
        row.style.setProperty('max-width', '100%', 'important');
        row.style.setProperty('box-sizing', 'border-box', 'important');
      });

      // Image wrapper
      var images = scope.querySelectorAll('.autocomplete-inner .fast-wide-products .fs-product-image');
      images.forEach(function (imgWrap) {
        if (!imgWrap || !imgWrap.style) return;
        imgWrap.style.setProperty('max-width', '80px', 'important');
        imgWrap.style.setProperty('max-height', '80px', 'important');
        imgWrap.style.setProperty('min-width', '80px', 'important');
        imgWrap.style.setProperty('min-height', '80px', 'important');
        imgWrap.style.setProperty('object-fit', 'contain', 'important');
      });

      // Image
      var imgs = scope.querySelectorAll('.autocomplete-inner .fast-wide-products .fs-product-image img');
      imgs.forEach(function (img) {
        if (!img || !img.style) return;
        img.style.setProperty('object-fit', 'contain', 'important');
      });
    } catch (e) {
      // no-op
    }
  }

  function observeRoot(root) {
    if (!('MutationObserver' in window)) return;
    if (!root || observedRoots.has(root)) return;

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        applyInlineStyles(root);
      }, 50);
    }

    var observer = new MutationObserver(function () {
      schedule();
    });

    try {
      observer.observe(root === document ? document.body : root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
      observedRoots.add(root);
    } catch (e) {
      // no-op
    }
  }

  function handleShadowRoot(shadowRoot) {
    if (!shadowRoot || !(shadowRoot instanceof ShadowRoot)) return;
    applyInlineStyles(shadowRoot);
    observeRoot(shadowRoot);
  }

  function initHost(hostEl) {
    if (!hostEl || hostEl.nodeType !== 1) return;

    // If shadowRoot isn't attached yet, retry a few times.
    if (!hostEl.shadowRoot) {
      if (hostEl.getAttribute('data-mh-ac-shadow-watch') === '1') return;
      hostEl.setAttribute('data-mh-ac-shadow-watch', '1');

      var tries = 0;
      var maxTries = 20; // ~4s at 200ms
      var intervalMs = 200;

      var timer = setInterval(function () {
        tries += 1;
        if (hostEl.shadowRoot) {
          clearInterval(timer);
          handleShadowRoot(hostEl.shadowRoot);
          return;
        }
        if (tries >= maxTries) {
          clearInterval(timer);
        }
      }, intervalMs);
      return;
    }

    handleShadowRoot(hostEl.shadowRoot);
  }

  function findAndInitHosts() {
    try {
      var hosts = document.querySelectorAll(hostSelector);
      for (var i = 0; i < hosts.length; i++) {
        initHost(hosts[i]);
      }
    } catch (e) {
      // no-op
    }
  }

  function observeForHosts() {
    if (!('MutationObserver' in window)) return;
    if (!document.body) return;

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        findAndInitHosts();
      }, 100);
    }

    var observer = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var mutation = mutations[m];

        // Case 1: host element is added to the DOM
        if (mutation.type === 'childList') {
          var added = mutation.addedNodes;
          if (!added || !added.length) continue;
          for (var i = 0; i < added.length; i++) {
            var node = added[i];
            if (!node || node.nodeType !== 1) continue;
            if ((node.matches && node.matches(hostSelector)) || (node.querySelector && node.querySelector(hostSelector))) {
              schedule();
              return;
            }
          }
        }

        // Case 2: existing element gets the class later (common on collection pages)
        if (mutation.type === 'attributes') {
          var t = mutation.target;
          if (t && t.nodeType === 1 && t.matches && t.matches(hostSelector)) {
            schedule();
            return;
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function init() {
    setTimeout(function () {
      findAndInitHosts();
      observeForHosts();
    }, injectDelayMs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

$(document).ready(function () {
  $(window).scroll(function () {
    $('#ui-id-1').css('display', 'none');

    if ($(document).scrollTop() > 60) {
      $('.header-new__mobile-menu').addClass('header-hidden');
      $('#HeaderCart').addClass('header-new--top-fix');
      $('#menu-sort-filter').addClass('collection-filter--add-border-bottom');
    } else {
      $('#menu-sort-filter').removeClass('collection-filter--add-border-bottom');
      $('.header-new__mobile-menu').removeClass('header-hidden');
      $('#HeaderCart').removeClass('header-new--top-fix');
    }

    if ($(window).width() > 768) {
      $('#HeaderCart').removeClass('header-new--top-fix');
    }
  });

  $(window).resize(function () {
    if ($(window).width() > 768) {
      $('#HeaderCart').removeClass('header-new--top-fix');
      $('#submenu-categories').slideDown('footer-new__sub-menu');
      $('#submenu-brands').slideDown('footer-new__sub-menu');
    } else {
      $('#HeaderCart').addClass('header-new--top-fix');
      if ($(document).scrollTop() <= 60) {
        $('#HeaderCart').removeClass('header-new--top-fix');
      }
    }
  });
});


function calculateFreeShipping(cartTotal) {
  let temp = document.getElementById('js-free-shipping');
  let freeShippingPrice = 0;
  if (temp && temp.value) {
    freeShippingPrice = temp.value * 100;
  }

  let isFreeShipping = false;

  const freeShippingMessageComplete = document.getElementById('js-free-shipping-message-complete').value;
  const freeShippingMessageNotComplete = document.getElementById('js-free-shipping-message-not-complete').value;
  const freeShippingMessageNotCompleteZero = document.getElementById('js-free-shipping-message-not-complete-zero').value;

  let percentageFreeShipping = 0;
  let messageProgress = freeShippingMessageComplete;
  if (cartTotal <= freeShippingPrice) {
    percentageFreeShipping = (100 * cartTotal) / freeShippingPrice;
    if (freeShippingPrice - cartTotal === 0) {
      messageProgress = freeShippingMessageNotCompleteZero;
    } else {
      messageProgress = theme.Currency.formatMoney(freeShippingPrice - cartTotal, theme.settings.moneyFormat) + freeShippingMessageNotComplete;
    }
    document.querySelector('#cart-delivery-info--not-free').style.display = '';
    document.querySelector('#cart-delivery-info--free').style.display = 'none';
  } else {
    percentageFreeShipping = 100;
    document.querySelector('#cart-delivery-info--not-free').style.display = 'none';
    document.querySelector('#cart-delivery-info--free').style.display = '';
    isFreeShipping = true;
  }

  document.querySelector(':root').style.setProperty('--freeShippingPercentage', percentageFreeShipping + '%');
  document.querySelector('.free-shipping-back').innerHTML = messageProgress;
  document.querySelector('.free-shipping-front').innerHTML = messageProgress;

  return isFreeShipping;
}

function toggleCartDrawer() {
  const checkIfCartIsOpen = document.querySelector('#HeaderCart').classList.contains('is-active');

  if (checkIfCartIsOpen) {
    document.dispatchEvent(new Event('cart:close'));
    document.querySelector('.overlay-drawer').style.display = 'none';
    document.querySelector('#cart-footer-subtotal').style.marginBottom = '0';
  } else {
    document.dispatchEvent(new Event('cart:open'));
    document.querySelector('.overlay-drawer').style.display = '';

    if ($(window).width() < 576) {
      // $('.header-new__mobile-menu').addClass('header-hidden')
      $('#HeaderWrapper').addClass('header-wrapper--compressed');
      if ($(document).scrollTop() > 60) {
        document.querySelector('.cart__footer').style.marginBottom = '0';
      } else {
        document.querySelector('.cart__footer').style.marginBottom = '40px';
      }
    }

    // if ($(window).width() < 1024 && $(window).width() > 576) {
    if ($(window).width() < 576) {
      if ($(document).scrollTop() > 60) {
        document.querySelector('#cart-footer-subtotal').style.marginBottom = '0';
      } else {
        //        document.querySelector('#cart-footer-subtotal').style.marginBottom = '100px'
      }
    }
  }
}

function toggleMenuDrawer() {
  const checkIfMenuIsOpen = document.querySelector('#MobileNav').classList.contains('is-active');

  if (checkIfMenuIsOpen) {
    document.dispatchEvent(new CustomEvent('mobileNav:close'));
    document.querySelector('.overlay-drawer').style.display = 'none';
  } else {
    document.dispatchEvent(new CustomEvent('mobileNav:open'));
    document.querySelector('.overlay-drawer').style.display = '';
  }
}

function toggleFilters(buttonName) {
  const filtersMenuChecked = document.querySelector('#CollectionInlineFilterWrap .filter-wrapper').classList.contains('is-active');

  const checkHeaderCompressed = document.querySelector('#HeaderWrapper').classList.contains('header-wrapper--compressed');

  // on mobile fix filter position
  if (checkHeaderCompressed) {
    if ($(window).width() <= 768) {
      $('#menu-sort-filter').addClass('collection-filter--on-mobile');
    } else {
      $('#menu-sort-filter').removeClass('collection-filter--on-mobile');
    }
  }

  if (filtersMenuChecked) {
    document.querySelector('#CollectionInlineFilterWrap .tag-list--active-tags').classList.remove('hide-filter-row');
    document.querySelector('#CollectionInlineFilterWrap .filter-form').classList.remove('hide-filter-row');
    document.querySelector('#CollectionInlineFilterWrap #sort-by-menu').classList.remove('hide-filter-row');

    document.querySelector('#sort-arrow').classList.remove('rotate270');
    document.querySelector('#sort-arrow').classList.add('rotate90');
    document.querySelector('#CollectionInlineFilterWrap .filter-wrapper__title').classList.remove('hide-filter-row');
  } else {
    if (buttonName === 'sort') {
      document.querySelector('#sort-arrow').classList.remove('rotate90');
      document.querySelector('#sort-arrow').classList.add('rotate270');
      document.querySelector('#CollectionInlineFilterWrap .filter-form').classList.add('hide-filter-row');
      document.querySelector('#CollectionInlineFilterWrap .filter-wrapper__title').classList.add('hide-filter-row');
      document.querySelector('#CollectionInlineFilterWrap .tag-list--active-tags').classList.add('hide-filter-row');
    } else {
      document.querySelector('#CollectionInlineFilterWrap #sort-by-menu').classList.add('hide-filter-row');
      document.querySelector('#CollectionInlineFilterWrap .filter-wrapper__title').classList.remove('hide-filter-row');
      document.querySelector('#CollectionInlineFilterWrap .tag-list--active-tags').classList.remove('hide-filter-row');
    }
  }
}

function expandCollectionContent(id) {
  $('#collectionContent-' + id).slideToggle();
  $('#arrow-' + id).toggleClass('rotate90');
}

function openSearchBar() {
  $('#header-search-mobile').toggleClass('header-new--hide');
  $('#header-search-mobile').toggleClass('header-new__mobile-search');

  if ($(window).width() <= 768) {
    if (document.querySelector('#header-search-mobile').classList.contains('header-new__mobile-search')) {
      document.querySelector('body').classList.add('cart--block-scroll-mobile');
      document.documentElement.classList.add('lock-scroll');
      document.querySelector('.overlay-drawer-mobile').style.display = '';
      document.querySelector('#search-mobile-button').classList.remove('icon-search');
      document.querySelector('#search-mobile-button').classList.add('icon');
      document.querySelector('#search-mobile-button').classList.add('icon-plus');
      document.querySelector('#search-mobile-button').classList.add('search-close-button');
      setTimeout(() => {
        if (/iPhone/i.test(navigator.userAgent)) {
          document.querySelector('#ui-id-4').classList.add('ui-autocomplete-height-ios');
        } else {
          document.querySelector('#ui-id-4').classList.add('ui-autocomplete-height-others');
        }
      }, 500);
    } else {
      document.querySelector('body').classList.remove('cart--block-scroll-mobile');
      document.documentElement.classList.remove('lock-scroll');
      document.querySelector('.overlay-drawer-mobile').style.display = 'none';
      document.querySelector('#search-mobile-button').classList.remove('icon');
      document.querySelector('#search-mobile-button').classList.remove('icon-plus');
      document.querySelector('#search-mobile-button').classList.remove('search-close-button');
      document.querySelector('#search-mobile-button').classList.add('icon-search');
      setTimeout(() => {
        if (/iPhone/i.test(navigator.userAgent)) {
          document.querySelector('#ui-id-4').classList.remove('ui-autocomplete-height-ios');
        } else {
          document.querySelector('#ui-id-4').classList.remove('ui-autocomplete-height-others');
        }
      }, 500);
    }
  }
}

function openMenu(id) {
  let listMenus = document.querySelectorAll('.header-new-menus__container');
  listMenus.forEach((menu) => {
    if (menu.id !== id) {
      menu.classList.remove('header-new-menus--visible');
    }
  });
  $('#' + id).addClass('header-new-menus--visible');
}

let megaMenuOpened = false;

function openMenuCro(id, element) {
  let listMenus = document.querySelectorAll('.header-new-menus-cro__container');
  listMenus.forEach((menu) => {
    if (menu.id !== id) {
      menu.classList.remove('header-new-menus-cro--visible');
    }
  });
  $('#' + id).addClass('header-new-menus-cro--visible');
}

function closeMenus() {
  let listMenus = document.querySelectorAll('.header-new-menus__container');
  listMenus.forEach((menu) => {
    menu.classList.remove('header-new-menus--visible');
  });
}

function megaMenuIsVisible() {
  let isOpen = false;
  const megaMenuItems = document.querySelectorAll('.header-new-menus-cro > ul');
  megaMenuItems.forEach((item) => {
    if (item.classList.contains('header-new-menus-cro--visible')) {
      isOpen = true;
    }
  });
  if (!isOpen) {
    const megaMenuItemsDiv = document.querySelectorAll('.header-new-menus-cro > div');
    isOpen = false;
    megaMenuItemsDiv.forEach((item) => {
      if (item.classList.contains('header-new-menus-cro--visible')) {
        isOpen = true;
      }
    });
  }

  return isOpen;
}

function checkMegaMenu() {
  const megaMenuItems = document.querySelectorAll('.header-new-menus-cro > ul');
  let isOpen = false;
  megaMenuItems.forEach((item) => {
    if (item.classList.contains('header-new-menus-cro--visible')) {
      isOpen = true;
    }
  });
  if (isOpen) {
    closeMenusCro();
  }
  const megaMenuItemsDiv = document.querySelectorAll('.header-new-menus-cro > div');
  isOpen = false;
  megaMenuItemsDiv.forEach((item) => {
    if (item.classList.contains('header-new-menus-cro--visible')) {
      isOpen = true;
    }
  });
  if (isOpen) {
    closeMenusCro();
  }
}

function closeMenusCro() {
  megaMenuOpened = false;
  document.querySelector('.overlay-drawer-cro').style.display = 'none';
  document.querySelector('.overlay-drawer-cro').classList.remove('overlay-drawer-cro--visible');
  let listMenus = document.querySelectorAll('.header-new-menus-cro__container');
  listMenus.forEach((menu) => {
    menu.classList.remove('header-new-menus-cro--visible');
  });
  document.querySelector('.overlay-drawer-cro').style.display = 'none';
}

function addToCart(variant_id, quantity) {
  const addData = {
    id: variant_id,
    quantity: quantity,
  };

  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(addData),
  })
    .then((response) => {
      response
        .json()
        .then((result) => {
          if (response.status === 200) {
            document.dispatchEvent(new Event('cart:build'));
            document.dispatchEvent(new Event('cart:open'));
          } else {
            if (result.description.indexOf('are in your cart') >= 0) {
              openAlert(allInCart);
            } else {
              openAlert(result.description);
            }
          }
        })
        .catch((error) => {
          console.log('catch', error);
        });
    })
    .catch((error) => {
      console.log('catch', error);
    });
}

function openCollapsibleContent(title, id) {
  if ($(window).width() > 768) {
    $('#collapsible-drawer-content__title').html(title);
    $('#collapsible-drawer-content__content').html($(`#content-tab-${id}`).html());
    $('#collapsible-drawer-content').addClass('collapsible-drawer-content--open');
    document.querySelector('.overlay-drawer').style.display = '';
    $(`#${id}`).removeClass('is-open');

  }
}

function closeCollapsibleContent(e) {
  document.querySelector('.overlay-drawer').style.display = 'none';
  document.querySelector('.overlay-drawer-mobile').style.display = 'none';
  $('#collapsible-drawer-content__title').html('');
  $('#collapsible-drawer-content__content').html('');
  $('#collapsible-drawer-content').removeClass('collapsible-drawer-content--open');
}

// use to add a product into the wishlist
function addToWishList(productId, variantId, productUrl, productImage, productTitle, currentProduct) {
  if (currentProduct.classList.contains('wishlist-new--icon-added')) {
    window._swat.removeFromWishList(
      {
        epi: variantId,
        du: productUrl,
        empi: productId,
        iu: productImage,
      },
      function (r) {
        let getAllProducts = document.querySelectorAll(`#wishlist-new__icon-${productId}`);
        getAllProducts.forEach((product) => {
          product.classList.remove('wishlist-new--icon-added');
        });
        updateWishlistCounter();
      }
    );
  } else {
    window._swat.addToWishList(
      {
        epi: variantId,
        du: productUrl,
        empi: productId,
        iu: productImage,
      },
      function (r) {
        let getAllProducts = document.querySelectorAll(`#wishlist-new__icon-${productId}`);
        getAllProducts.forEach((product) => {
          product.classList.add('wishlist-new--icon-added');
        });
        updateWishlistCounter();

        document.querySelector('#wishlist-popup__image').src = productImage;
        document.querySelector('#wishlist-popup__title').innerHTML = productTitle;

        document.querySelector('#wishlist-popup').classList.add('wishlist-popup--opened');
        setTimeout(() => {
          document.querySelector('#wishlist-popup').classList.remove('wishlist-popup--opened');
          document.querySelector('#wishlist-popup__image').src = '';
        }, 2000);
      }
    );
  }
}

// update wishlist status after infinite scroll loaded more products
function updateWishlistStatus() {
  document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
}

function closeDrawersMobile() {
  openSearchBar();
}

function closeDrawers() {
  let checkProductDrawers = document.querySelector('#collapsible-drawer-content');
  if (checkProductDrawers) {
    closeCollapsibleContent();
  }
}

function addUpselProductsToCart() {
  let upsellProducts = document.querySelectorAll('[upsell-selected="1"]');
  let counterProducts = 0;
  let maxProducts = upsellProducts.length;
  let upsellProductsToAdd = [];

  if (upsellProducts && upsellProducts.length) {
    for (let i = 0; i < upsellProducts.length; i++) {
      if (upsellProducts[i].getAttribute('is-a-bundle') === 'true') {
        let dataBundle = {
          id: upsellProducts[i].getAttribute('variant-id'),
          quantity: 1,
          properties: {
            _quantityPerProduct: upsellProducts[i].getAttribute('quantity-per-product'),
          },
        };

        dataBundle.properties['_' + upsellProducts[i].getAttribute('sku')] = upsellProducts[i].getAttribute('quantity-per-product') + '@' + upsellProducts[i].getAttribute('handle');

        upsellProductsToAdd.push(dataBundle);
      } else {
        upsellProductsToAdd.push({
          id: upsellProducts[i].getAttribute('variant-id'),
          quantity: 1,
        });
      }
    }
    let data = {
      items: upsellProductsToAdd,
    };
    fetch('/cart/add.js', {
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
      },
      method: 'POST',
    })
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        if (json.status !== 200 && json.description) {
          showPopupMessage(json.description);
        } else {
          // products were added
          document.dispatchEvent(new Event('cart:build'));
          setTimeout(() => {
            document.dispatchEvent(new Event('cart:open'));
          }, 100);
          upsellProducts.forEach((temp) => {
            temp.setAttribute('upsell-selected', '0');
            temp.style.backgroundColor = '#f4f4f4';
            let iconElement = temp.querySelector('span');
            iconElement.style.color = '#242424';
            iconElement.classList.remove('icon-check-short');
            iconElement.classList.add('icon-plus');
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
}

let observerWishlist = null;
// mutation to update wishlist counter
function runMutationWishlist() {
  if (!observerWishlist) {
    let target = document.querySelector('.swym-wishlist-modal-container').firstChild;
    // create an observer instance
    observerWishlist = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        updateWishlistCounter();

        // update wishlist status after infinite scroll loaded more products
        updateWishlistStatus();
      });
    });

    // configuration of the observer:
    let config = { attributes: true, childList: true, characterData: true };

    // pass in the target node, as well as the observer options
    observerWishlist.observe(target, config);
  }
}

function openReviewTab(title, id) {
  if ($(window).width() > 768) {
    openCollapsibleContent(title, id);
  } else {
    document.querySelector(`#btn-${id}`).click();
  }
}

function deleteItemFromCart(itemId) {
  let addData = {
    updates: {},
  };

  addData.updates[itemId] = 0;

  fetch('/cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(addData),
  })
    .then((response) => {
      if (response.status === 200) {
        document.dispatchEvent(new Event('cart:build'));
      }
    })
    .catch((error) => {
      console.log('catch', error);
    });
}

// wholesale functions
let productsCounter = 0;

function modifyQuantity(variantId, minusPlus) {
  var quantity = document.querySelector('input[variant-id="' + variantId + '"]').value;
  var newQuantity = parseInt(quantity) + minusPlus;
  if (newQuantity < 0) {
    newQuantity = 0;
  } else {
    productsCounter = productsCounter + minusPlus;
  }

  if (productsCounter <= 0) {
    productsCounter = 0;
    document.querySelector('.collection-wholesale-product__selected').innerHTML = '';
    document.querySelector('.collection-wholesale-product__add-to-cart-container').classList.remove('collection-wholesale-product__add-to-cart-container--show');
  } else {
    const productsCounterText = productsCounter == 1 ? productCounterMessage : productCounterMessageMore;
    document.querySelector('.collection-wholesale-product__selected').innerHTML = `${productsCounter} ${productsCounterText}`;
    document.querySelector('.collection-wholesale-product__add-to-cart-container').classList.add('collection-wholesale-product__add-to-cart-container--show');
  }

  document.querySelector('input[variant-id="' + variantId + '"]').value = newQuantity;
}

function quantityChanged(variantId, currentValue) {
  if (currentValue.length == 0) {
    currentValue = 0;
  }

  let tempTotal = 0;
  let allQuantity = document.querySelectorAll('.collection-wholesale-product__quantity-selector-input');
  allQuantity.forEach((elem) => {
    let tempQuantity = 0;
    if (elem.value.length > 0) {
      tempQuantity = elem.value;
    }
    tempTotal = tempTotal + Number(tempQuantity);
  });

  productsCounter = tempTotal;

  if (productsCounter <= 0) {
    productsCounter = 0;
    document.querySelector('.collection-wholesale-product__selected').innerHTML = '';
    document.querySelector('.collection-wholesale-product__add-to-cart-container').classList.remove('collection-wholesale-product__add-to-cart-container--show');
  } else {
    const productsCounterText = productsCounter == 1 ? productCounterMessage : productCounterMessageMore;
    document.querySelector('.collection-wholesale-product__selected').innerHTML = `${productsCounter} ${productsCounterText}`;
    document.querySelector('.collection-wholesale-product__add-to-cart-container').classList.add('collection-wholesale-product__add-to-cart-container--show');
  }
}

function clearInputs() {
  let variantInput = document.querySelectorAll('.collection-grid ul li .collection-wholesale-product__quantity-selector-input');
  variantInput.forEach((item) => {
    item.value = 0;
  });

  productsCounter = 0;
  document.querySelector('.collection-wholesale-product__selected').innerHTML = '';
  document.querySelector('.collection-wholesale-product__add-to-cart-container').classList.remove('collection-wholesale-product__add-to-cart-container--show');
}

function showPopupMessage(message) {
  document.querySelector('.collection-wholesale-product__popup span').innerHTML = message;
  document.querySelector('.collection-wholesale-product__popup').classList.add('collection-wholesale-product__popup--show');
  setTimeout(() => {
    document.querySelector('.collection-wholesale-product__popup').classList.remove('collection-wholesale-product__popup--show');
  }, 5000);
}

function addToBasket() {
  let variantToAdd = [];
  let productsNotStock = [];

  const allVariants = document.querySelectorAll('.collection-grid ul');

  // get all quantity Inputs
  allVariants.forEach((oneVariant) => {
    let variantInput = oneVariant.querySelectorAll('li .collection-wholesale-product__quantity-selector-input');

    // for each input check if the value is greater than 0, in that case add the variant to the array
    variantInput.forEach((variantInfo) => {
      // check if the product is a bundle

      isBundle = variantInfo.getAttribute('is-bundle');

      if (variantInfo.value > 0) {
        let variantId = variantInfo.getAttribute('variant-id') * 1;
        if (isBundle == '__bundle') {
          // get the master quantity
          let masterInfo = document.querySelector(`.product-variant-bundle-info--${variantId}`);
          let quantityPerProduct = masterInfo.getAttribute('master-quantity') * 1;

          let masterInfoSku = masterInfo.getAttribute('master-sku');
          if (masterInfoSku) masterInfoSku = masterInfoSku.trim();

          // check inventory of master products
          let infoQuantityBundle = document.querySelector(`#master-info--${variantId}`);
          if (infoQuantityBundle) {
            infoQuantityBundle = infoQuantityBundle.getAttribute('info');
            if (infoQuantityBundle && infoQuantityBundle.length) {
              infoQuantityBundle = Number(infoQuantityBundle);
            } else {
              infoQuantityBundle = 0;
            }
          }

          if (infoQuantityBundle > quantityPerProduct * variantInfo.value) {
            variantToAdd.push({
              id: variantId,
              quantity: variantInfo.value * 1,
              properties: {
                _quantityPerProduct: quantityPerProduct,
              },
            });
            variantToAdd[variantToAdd.length - 1].properties[`_${masterInfoSku}`] = `${masterInfo.getAttribute('master-quantity')}@${masterInfo.getAttribute('master-handle')}`;
          } else {
            productsNotStock.push(masterInfo.getAttribute('master-name') + ' - Available: ' + infoQuantityBundle);
          }
        } else {
          variantToAdd.push({
            id: variantId,
            quantity: variantInfo.value * 1,
          });
        }
      }
    });
  });

  //show products without inventory
  let messageOutStock = '';
  if (productsNotStock) {
    productsNotStock.forEach((product) => {
      messageOutStock += `<li>${product}</li>`;
    });
    messageOutStock += `</ul>`;
  }

  if (variantToAdd.length > 0) {
    // add the items to the data object we need to pass to the fetch call
    let data = {
      items: variantToAdd,
    };

    showPopupMessage(messageAdding + messageOutStock);

    fetch('/cart/add.js', {
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
      },
      method: 'POST',
    })
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        if (json.status !== 200 && json.description) {
          showPopupMessage(json.description);
        } else {
          productsCounter = 0;
          clearInputs();
          // products were added
          document.dispatchEvent(new Event('cart:build'));
          document.dispatchEvent(new Event('cart:open'));
        }
      })
      .catch((err) => {
        console.error(err);
      });
  } else {
    showPopupMessage(messageSelectAnotherQuantity);
  }
}

function expandMenuChild(handle) {
  // close all icons
  const allIcons = document.querySelectorAll(`.icon-child-chevron`);
  const isOpen = document.querySelector(`.icon-${handle}`).classList.contains('icon--rotate');

  allIcons.forEach((item) => {
    if (item.classList.contains('icon--rotate')) {
      item.classList.remove('icon--rotate');
    }
  });

  if (isOpen) {
    document.querySelector(`.icon-${handle}`).classList.remove('icon--rotate');
  } else {
    document.querySelector(`.icon-${handle}`).classList.add('icon--rotate');
  }

  // close all lists
  const allLists = document.querySelectorAll('.expand-list-child--cro');
  allLists.forEach((item) => {
    item.classList.remove('expand-list-child');
    item.classList.remove('expand-list-child--cro');
  });
  if (!isOpen) {
    const listToExpand = document.querySelector('[data-parent="' + handle + '"]');
    listToExpand.classList.add('expand-list-child');
    listToExpand.classList.add('expand-list-child--cro');
  }
}

function expandMenu(handle) {
  const parentHandle = document.querySelector('.' + handle + '-parent');
  let isOpen = parentHandle.classList.contains('background--active');

  // close all the other menus
  const allMenus = document.querySelectorAll('.slide-nav__button');
  allMenus.forEach((item) => {
    if (item.classList.contains('background--active')) {
      item.classList.remove('background--active');
    }
  });
  // close all icons
  const allIcons = document.querySelectorAll('.icon-chevron-right ');
  allIcons.forEach((item) => {
    if (item.classList.contains('icon--rotate')) {
      item.classList.remove('icon--rotate');
    }
  });
  // close all lists
  const allLists = document.querySelectorAll('.expand-list');
  allLists.forEach((item) => {
    item.classList.remove('expand-list');
  });

  if (handle.indexOf('cro') > -1) {
    const allListsCro = document.querySelectorAll('.expand-list--cro');
    allListsCro.forEach((item) => {
      item.classList.remove('expand-list--cro');
    });
  }

  if (!isOpen) {
    const listToExpand = document.querySelector('[data-parent="' + handle + '"]');
    listToExpand.classList.add('expand-list');
    if (handle.indexOf('cro') > -1) {
      listToExpand.classList.add('expand-list--cro');
    }
    document.querySelector('.icon-' + handle).classList.add('icon--rotate');
    if (parentHandle) {
      parentHandle.classList.add('background--active');
      // scroll to parentHandle
      parentHandle.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }
}

function showSubLevel(id, total) {
  for (let i = 1; i <= total; i++) {
    document.querySelector(`#ul-sublevel-${i}`).classList.add('submenu-cro-sublevel--hide');
  }
  document.querySelector(`#ul-sublevel-${id}`).classList.remove('submenu-cro-sublevel--hide');
  for (let i = 1; i <= total; i++) {
    document.querySelector(`#ul-title-sublevel-${i}`).classList.remove('submenu-cro-sublevel--selected');
  }
  document.querySelector(`#ul-title-sublevel-${id}`).classList.add('submenu-cro-sublevel--selected');
}

function openDescription(value) {
  let allDescriptions = document.querySelector('.description-new-cro__content');

  if (value === 1) {
    allDescriptions.classList.add('description-new-cro__content--show');
    document.querySelector('#open_description').classList.add('description-new-cro--hide');
    document.querySelector('.description-new-cro__bottom-overlay').classList.add('description-new-cro--hide');
    document.querySelector('#close_description').classList.remove('description-new-cro--hide');
  } else {
    allDescriptions.classList.remove('description-new-cro__content--show');
    document.querySelector('#open_description').classList.remove('description-new-cro--hide');
    document.querySelector('.description-new-cro__bottom-overlay').classList.remove('description-new-cro--hide');
    document.querySelector('#close_description').classList.add('description-new-cro--hide');
  }
}
